import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { CommonService } from '../../common-service';
import { environment } from '../../../../../environments/environment';
import { ReturnStruct } from '../../structs/return.struct';
import { AcessoResulthLocalConnectResponse } from '../../responses/interface-resulth-local-connect/acesso-resulth-local-connect.response';
import { TokenAcessoResulthLocalConnectResponse } from '../../responses/interface-resulth-local-connect/token-acesso-resulth-local-connect.response';
import { AcessoResulthLocalConnectRequest } from '../../requests/interface-resulth-local-connect/acesso-resulth-local-connect.request';

@Injectable({
  providedIn: 'root',
})
export class AcessoResulthLocalConnectService extends CommonService {
  constructor(
    private router: Router,
    private httpClient: HttpClient
  ) {
    super();
  }

  public get(idEmpresa: number): Observable<AcessoResulthLocalConnectResponse> {
    const uri: string = `AcessoResulthLocalConnect/idEmpresa/${idEmpresa}`

    return this.httpClient
      .get<AcessoResulthLocalConnectResponse>(environment.urlApiInterfaceResulthLocalConnect + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public excluir(idEmpresa: number, matriz: boolean = false): Observable<ReturnStruct> {
    const query = matriz ? `?matriz=${matriz}` : '';
    return this.httpClient
      .delete<ReturnStruct>(
        environment.urlApiInterfaceResulthLocalConnect + `AcessoResulthLocalConnect/idEmpresa/${idEmpresa}${query}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public incluir(idEmpresa: number, acessoResulthLocalConnectRequest: AcessoResulthLocalConnectRequest): Observable<AcessoResulthLocalConnectResponse> {
    return this.httpClient
      .post<AcessoResulthLocalConnectResponse>(environment.urlApiInterfaceResulthLocalConnect + `AcessoResulthLocalConnect/idEmpresa/${idEmpresa}`,
        acessoResulthLocalConnectRequest, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public alterar(idEmpresa: number, acessoResulthLocalConnectRequest: AcessoResulthLocalConnectRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(environment.urlApiInterfaceResulthLocalConnect + `AcessoResulthLocalConnect/idEmpresa/${idEmpresa}`,
        acessoResulthLocalConnectRequest, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public generateToken(idEmpresa: number): Observable<TokenAcessoResulthLocalConnectResponse> {
    return this.httpClient
      .get<TokenAcessoResulthLocalConnectResponse>(
        environment.urlApiInterfaceResulthLocalConnect + `AcessoResulthLocalConnect/token/generate/idEmpresa/${idEmpresa}`,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }
}
